const EventEmitter = require('events').EventEmitter
var moment = require('moment')
moment.locale('it')
import axios from './tAxios'
import storage from './tStorage'

import dbItem from './dbItem'


class socio{
   constructor (args) {
      this.event = new EventEmitter()
      this.moment = moment
      this.societa = 1100
      this.sigla = 'SIAIP'
      this.contatto = new dbItem({database:'bm_limmsy',table:'contatto'})
      this.si = new dbItem({table:'statoiscrizione'})
      this._societa = []
      this._si = []
      this._rinnovo = []
      this._versamento = []
      this._mezzo = []
      this._nextquoteDetail = []
      this._nextquote = []


      axios.query('fetchAll',`SELECT * FROM mezzo WHERE 1 ORDER BY nome`,{id: this.contatto.row.id},this,'_mezzo')
      axios.query('fetchAll',`SELECT * FROM societa WHERE attivo=1 ORDER BY peso,tipo,sigla,nome`,{id: this.contatto.row.id},this,'_societa')



      this.contatto.event.on('loaded', () =>{

         storage.save('socio',this.contatto.row.id)
         this.init()

         
          
      })
      
      return this
   }

   getSi(){
      axios.query('fetchOne',`SELECT id FROM statoiscrizione WHERE contatto=→id AND societa=→societa ORDER BY id`,{id: this.contatto.row.id, societa: this.societa}).then((response) =>  {
         this.si.load(response.result)
      })
   }

   getStatoiscrizione(){
      axios.query('fetchAll',`SELECT * FROM statoiscrizione WHERE contatto=→id  ORDER BY id`,{id: this.contatto.row.id, societa: this.societa},this,'_si')
   }
   
   getRrinnovi(){
      axios.query('fetchAll',`SELECT * FROM rinnovo WHERE contatto=→id ORDER BY societa,anno DESC`,{id: this.contatto.row.id},this,'_rinnovo')
   }
   
   getVersamenti(){
      axios.query('fetchAll',`SELECT * FROM versamento WHERE contatto=→id ORDER BY eseguitoil DESC`,{id: this.contatto.row.id},this,'_versamento')
   }

   getNextquote(){
      axios.query('fetchAll',`call next_quote(→id,→sezione,'summary')`,{id: this.contatto.row.id,sezione:this.societa/100},this,'_nextquote')
   }

   getNextquoteDetail(){
      axios.query('fetchAll',`call next_quote(→id,→sezione,'detail')`,{id: this.contatto.row.id,sezione:this.societa/100},this,'_nextquoteDetail')
   }


   async init(){
      await axios.query('query',`UPDATE statoiscrizione SET dbaction=1 WHERE dbaction=-1;`)
      return new Promise(async (resolve, reject) => {
         
         await this.getSi()
         await this.getNextquote()
         await this.getNextquoteDetail()
         await this.getRrinnovi()
         await this.getVersamenti()
         await this.getStatoiscrizione()
         resolve("Fatto")
      })
   }

   checkEmail(emailCheck,contatto){
      return new Promise((resolve, reject) => {
        axios.query('fetchOne',`SELECT email FROM bm_limmsy.contatto WHERE email=→email AND id!=→contatto LIMIT 1`,{contatto:contatto,email:emailCheck},this,'pagine').then((response) => {
          var controllo = (response.result == emailCheck) ? false : true
          resolve(controllo)
        })
      })
    }

}
export default new socio
